// core/composables/handlers/errorHandler.ts
// @ts-ignore
import { reactive } from 'vue';

export function errorHandler() {
  const errors = reactive<{ [key: string]: string }>({});

  // Clear all errors
  function resetErrors() {
    Object.keys(errors).forEach((key) => {
      delete errors[key];
    });
  }

  // Map errors to form fields
  function handleFormErrors(payload: { [key: string]: string | string[] }) {
    resetErrors(); // Clear previous errors before assigning new ones

    // Assign errors dynamically to form fields based on the payload
    // @ts-ignore
    Object.entries(payload).forEach(([field, message]) => {
      if (Array.isArray(message)) {
        errors[field] = message.join(', ');
      } else {
        errors[field] = message;
      }
    });
  }

  return { errors, handleFormErrors, resetErrors };
}
